import { __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
const PinTL = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Position, Object.assign({ left: 0, position: "absolute", ref: ref, top: 0 }, props), children));
});
export default PinTL;
